import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCXedientable = React.memo(function BCXedientable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [soluongxe, setSoluongxe] = React.useState(0);
  const [sokhachvanchuyen, setSokhachvanchuyen] = React.useState(0);
  const [sokhachluanchuyen, setSokhachluanchuyen] = React.useState(0);
  const [sochuyenthuchien, setSochuyenthuchien] = React.useState(0);
  const [sochuyenkehoach, setSochuyenkehoach] = React.useState(0);
  const [sochuyen_tyle, setSochuyen_tyle] = React.useState(0);
  const [sotuyenhoatdong, setSotuyenhoatdong] = React.useState(0);
  const [sonhanvienlaixe, setSonhanvienlaixe] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/Phuongtien/bcslthxedien?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) {
          setSoluongxe(data[0].soluongxe);
          setSokhachvanchuyen(data[0].sokhachvanchuyen);
          setSokhachluanchuyen(data[0].sokhachluanchuyen);
          setSochuyenthuchien(data[0].sochuyenthuchien);
          setSochuyenkehoach(data[0].sochuyenkehoach);
          setSochuyen_tyle(data[0].sochuyen_tyle);
          setSotuyenhoatdong(data[0].sotuyenhoatdong);
          setSonhanvienlaixe(data[0].sonhanvienlaixe);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số lượng xe</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{soluongxe}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Số khách vận chuyển</td>
          <td className={classes.tablebc_td}>lượt khách</td>
          <td className={classes.tablebc_td}>{sokhachvanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Số khách luân chuyển</td>
          <td className={classes.tablebc_td}>lượt khách</td>
          <td className={classes.tablebc_td}>{sokhachluanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Số chuyến thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyenthuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>5</td>
          <td className={classes.tablebc_td}>Số chuyến kế hoạch</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyenkehoach}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>-</td>
          <td className={classes.tablebc_td}>Tỷ lệ</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{sochuyen_tyle}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>6</td>
          <td className={classes.tablebc_td}>Số tuyến</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyenhoatdong}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>7</td>
          <td className={classes.tablebc_td}>Số nhân viên lái xe</td>
          <td className={classes.tablebc_td}>nhân viên</td>
          <td className={classes.tablebc_td}>{sonhanvienlaixe}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaoxedien" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCXedientable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCXedientable;
